import useDataRequest from './useDataRequest';
import http from 'utils/request';
import qs from 'qs';

/**
 * 新闻数据请求 Hook
 */
export const useNewsList = (params, options) => {
  const { immediate } = options;
  const paramsString = qs.stringify(params);
  return useDataRequest(
    'newsCache',
    () => http.get('/gwapi/News/frontIndex?' + paramsString),
    {
      immediate,
      useCache: false,
    },
  );
};

/**
 * 新闻详情请求 Hook
 * @param {string} id - 新闻ID
 */
export const useNewsDetail = (id) => {
  return useDataRequest(
    `newsDetail`,
    () => http.get(`/gwapi/News/frontShow/${id}`),
    {
      immediate: false,
      useCache: false,
    },
  );
};
